import { render } from "./GreenTextBlocks.vue?vue&type=template&id=1eb34b01"
import script from "./GreenTextBlocks.vue?vue&type=script&lang=js"
export * from "./GreenTextBlocks.vue?vue&type=script&lang=js"

import "./GreenTextBlocks.vue?vue&type=style&index=0&id=1eb34b01&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__